import { useMemo } from "react";
import { useSelector } from "react-redux";

// Read-only view of the logged-in user (loaded from the API into Redux by App).
// `id` is a string to match what the old localStorage-based reads returned, so
// existing comparisons and payloads keep behaving the same.
export const useCurrentUser = () => {
  const user = useSelector((state) => state.selectOptions?.loginUserName);

  return useMemo(
    () => ({
      user,
      id: user?.id != null ? String(user.id) : null,
      name: user?.name ?? null,
      email: user?.email ?? null,
      role: user?.role ?? null,
      isLoaded: Boolean(user),
    }),
    [user]
  );
};

export default useCurrentUser;
